import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {
  menuSections: any[] = [
    {
      title: 'Gestión',
      items: [
        { label: 'Usuarios', icon: '👤', route: '/admin/usuarios/lst' },
        { label: 'Categorías', icon: '🏷️', route: '/admin/categorias/lst' },
        { label: 'Grupos', icon: '🧩', route: '/admin/grupos/lst' },
        { label: 'Mercaderías', icon: '🛍️', route: '/admin/mercaderias/lst' },
        { label: 'Compras', icon: '🧾', route: '/admin/ingresos/lst' },
        { label: 'Ventas', icon: '💰', route: '/admin/ventas/lst' },
        { label: 'Caja operador', icon: '🏦', route: '/admin/detallecajas/lst' }
      ]
    },
    {
      title: 'Reportes',
      items: [
        { label: 'Stock', icon: '📦', route: '/admin/reporte/stock' },
        { label: 'Por Usuario', icon: '👥', route: '/admin/reporte/entrega' },
        { label: 'Total por Usuario', icon: '📊', route: '/admin/reporte/total' },
        { label: 'Por Cajas', icon: '🏦', route: '/admin/reporte/caja' },
        /* { label: 'Por Categoría', icon: '🗂️', route: '/admin/reporte/categoria' },*/
        { label: 'Por Producto', icon: '📦', route: '/admin/reporte/producto' }
      ]
    }
  ];
  constructor() { }

  ngOnInit() {
  }

  public sidebarCollapsed = false;

  toggleSidebar() {
    this.sidebarCollapsed = !this.sidebarCollapsed;
  }


}
